<template>
  <AsyncImage :src="getAbsoluteAssetLink(`nami/stickers/${name}.png`)" />
</template>

<script setup lang="ts">
defineProps<{
  name:
    | "angry"
    | "confused"
    | "cry"
    | "empty"
    | "happy"
    | "laugh"
    | "love"
    | "no_connection"
    | "no_search_results"
    | "okay"
    | "sad"
    | "sleep"
    | "surprised"
    | "thankyou"
    | "wink";
}>();
</script>
